/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';

export const getReviewHistoryV3RequestSchema = z
  .object({
    cursor: z.string().regex(/^\d+$/).optional(),
    from: z.number().int().min(0).optional(),
    to: z.number().int().min(0).optional(),
  })
  .refine((value) => value.from === undefined || value.to === undefined || value.to >= value.from, {
    message: 'to must be greater than or equal to from',
  });

export type IGetReviewHistoryV3Request = z.infer<typeof getReviewHistoryV3RequestSchema>;
